exports.onRouteUpdate = () => {
    // window.analytics && window.analytics.page();
};
